import {Component, OnDestroy, OnInit} from '@angular/core';

import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserInfoModel} from '../../services/models/user-info.model';
import {UserService} from '../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../services/events.service';
import {ProgressModel} from '../../services/models/progress.model';
import {environment} from '../../../environments/environment';
import {AnalyticsService} from '../../services/analytics.service';
import {NavService} from '../../services/nav.service';
import {LeaderboardModel} from '../leaderboard/models/leaderboard.model';
import {LeaderboardService} from '../leaderboard/service/leaderboard.service';
import {JourneyService} from '../journey/service/journey.service';
import {TasksModel} from '../tasks/models/tasks.model';
import {TasksService} from '../tasks/tasks.service';
import {Platform} from '@ionic/angular';

import * as striptags from 'striptags';

@Component({
    selector: 'app-home-inspire-page',
    templateUrl: 'home-inspire.page.html',
    styleUrls: ['home-inspire.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class HomeInspirePage implements OnInit, OnDestroy {

    // @ViewChild('svgReport360') svgReport360: ElementRef;

    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    userInfo: UserInfoModel = null;
    userInfoPromise: Promise<UserInfoModel> = null;
    userInfoValid = false;
    userType = null;

    leaderboardData: LeaderboardModel[] = null;
    leaderboardPromise: Promise<LeaderboardModel[]> = null;
    leaderboardValid = false;

    leaderboardDataTeam: LeaderboardModel[] = null;
    leaderboardDataSelf: LeaderboardModel = null;
    leaderboardDataSelfPosition = 0;

    upcomingEventsList: TasksModel[] = null;
    upcomingEventsPromise: Promise<TasksModel[]> = null;
    upcomingEventsValid = false;

    objectives = [
        {
            title: '__HOME_INSPIRE_OBJECTIVE_1__',
            content: '',
        }, {
            title: '__HOME_INSPIRE_OBJECTIVE_2__',
            content: '',
        }, {
            title: '__HOME_INSPIRE_OBJECTIVE_3__',
            content: '',
        }, {
            title: '__HOME_INSPIRE_OBJECTIVE_4__',
            content: '',
        }
    ];

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;
    platform = 'website';
    toggleSectionId = null;
    isOpened = false;
    interval = null;

    socialIcon = false;
    leaderboardIcon = false;

    socialUrl: string = null;

    link360 = {
        "11988" :"https://my721.com/report360_form/c74485edb2eca646e85af7cd3e12860c/",
        "11989" :"https://my721.com/report360_form/3e48c7a33050dbea43f5aa48faaaec9a/",
    };

    linkInsight = {
        "11988" :"https://my721.com/resource/cb24b81908b72a21943f7340ebc16f64/",
    };

    isPanelObjectives = false;
    isPanelLeaderboard = false;
    isPanelPersonalInsight = false;
    isPanelReflectionLog = false;

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private activatedRoute: ActivatedRoute,
        private leaderboardService: LeaderboardService,
        private journeyService: JourneyService,
        private tasksService: TasksService,
        private platformService: Platform,
        private nav: NavService,
        private router: Router,
    ) {
        this.environment = environment;
        this.platform = this.authService.appMobile ? 'mobile' : 'website';

        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.userInfoValid = false;
                this.leaderboardValid = false;
                this.progressValid = false;
                this.upcomingEventsValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => {
                this.userInfoValid = false;
                this.leaderboardValid = false;
                this.upcomingEventsValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('simulator.saveMySimulatorResult', () => {
                this.leaderboardValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('tasks:updateTaskClick', () => {
                this.leaderboardValid = false;
                this.upcomingEventsValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('account.saveMyProfileForm', () => this.userInfoValid = false)
        );

        if (this.userService.userInfo !== null) {
          this.initJourneys(this.userService.userInfo);
          this.userInfoValid = true;
        }

        this.interval = setInterval(() => {this.userInfoValid = false;}, 10000)
    }

    ngOnInit(): void {
        // this.platform = environment.platform;
    }


    ionViewWillEnter() {
        this.menuVisible = false;
        this.userType = this.authService.getUserType();

        if (this.userInfo === null || !this.userInfoValid) {
            console.log('ionViewWillEnter > getUserInfo')
            this.userInfoPromise = this.userService.getUserInfo();
        }

        if (this.leaderboardData === null || !this.leaderboardValid) {
            if (this.userService.userInfo?.client_id === 134) {
                this.leaderboardPromise = this.leaderboardService.getLeaderboardWorld([363], 'world');
            } else {
                this.leaderboardPromise = this.leaderboardService.getLeaderboard();
            }
        }

        if (this.upcomingEventsList === null || !this.upcomingEventsValid) {
            this.upcomingEventsPromise = this.tasksService.getMyUpcomingEventsList();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Veeam Home');

        if (this.userInfo === null || !this.userInfoValid) {
            this.userInfoPromise.then(data => {
              this.initJourneys(data);
              this.userInfoValid = true;
            });
        }

        if (this.leaderboardData === null || !this.leaderboardValid) {
            this.leaderboardPromise.then(data => {
                this.leaderboardData = data;
                this.leaderboardDataSelfPosition = data.findIndex((item) => item.delegate_id === this.userInfo.id);
                this.leaderboardDataSelf = data[this.leaderboardDataSelfPosition];

                if (this.leaderboardDataSelfPosition > 2) {
                    this.leaderboardDataTeam = data.slice(0, 3);
                } else {
                    this.leaderboardDataTeam = data.slice(0, 3);
                }

                this.leaderboardValid = true;
            });
        }

        if (this.upcomingEventsList === null || !this.upcomingEventsValid) {
            this.upcomingEventsPromise.then(data => {
                this.upcomingEventsList = data;
                this.upcomingEventsValid = true;
            });
        }

        // this.restartAnimation();
        //
        // this.renderer.listen(this.svgReport360.nativeElement, 'click', () => {
        //     this.restartAnimation();
        // });
    }

    // private restartAnimation() {
    //     const svg = this.svgReport360.nativeElement;
    //     const svgContent = svg.innerHTML;
    //     this.renderer.setProperty(svg, 'innerHTML', '');
    //     this.renderer.setProperty(svg, 'innerHTML', svgContent);
    // }

    initJourneys(userInfo) {
        // Twinings
        if (userInfo.client_id === 134) {
            this.isPanelObjectives = true;
            this.isPanelLeaderboard = true;
            this.isPanelPersonalInsight = true;
            this.isPanelReflectionLog = true;
        }

        if (!!userInfo.dashboard
            && !!userInfo.dashboard.enabled_social
            && !!userInfo.dashboard.social_url) {
            this.socialUrl = userInfo.dashboard.social_url + '?i=' + userInfo.meet_user;
        }
        this.socialIcon = this.authService.getUserCompanyEnabledSocial();
        this.leaderboardIcon = this.authService.getUserCompanyEnabledLeaderboard();

        if (!!userInfo.dashboard && userInfo.dashboard.sections.length > 0) {
            userInfo.dashboard.sections.forEach((section, index) => {
                section.template = userInfo.templates.find((t) => t.template.uid === section.uid) || null;

                if (section.sections.length > 0) {
                    section.sections = section.sections.map((subSection, index) => {
                      subSection.template = userInfo.templates.find((t) => t.template.uid === subSection.uid) || null;
                      return subSection;
                    }).filter((subSection) =>
                      !!subSection.template
                      || (subSection.uid === 'COACHING_JOURNEY' && userInfo.is_coaching)
                      || (subSection.uid === 'SKILLSCHECKER' && userInfo.is_skillschecker)
                    )
                    .map((subSection) => {
                      subSection.disabled = subSection.template && subSection.template.stages.active.length === 0;
                      return subSection;
                    });
                }
            })
        }

        this.userInfo = userInfo;
        console.log('userInfo', this.userInfo);

        if (this.isPanelObjectives) {
            let stream_function = striptags.init_streaming_mode(["br"]);

            this.journeyService.getPageData(1, 315).then((data) => {
                if (!!data.details && data.details.list.length > 0) {
                    data.details.list.forEach((section, index) => {
                        switch (section.id) {
                            case 8721:
                                this.objectives[0].content = stream_function(section.details.custom_textbox.value.output);
                                break;
                            case 8722:
                                this.objectives[1].content = stream_function(section.details.custom_textbox.value.output);
                                break;
                            case 8723:
                                this.objectives[2].content = stream_function(section.details.custom_textbox.value.output);
                                break;
                            case 8724:
                                this.objectives[3].content = stream_function(section.details.custom_textbox.value.output);
                                break;
                        }
                    });
                }
            })
        }

        let journey = this.activatedRoute.snapshot.paramMap.get('journey');
        if (!!journey) {
            const section= this.userInfo.dashboard.sections.find(
                (section) => section.template.template.uid === journey
            );
            if (!!section) {
                this.goToJourney(section.template.template_id)
            }
        }
    }

    buttonClicked(section) {
        if (section.uid === 'COACHING_JOURNEY') {
            this.nav.navigate(['/coach/journey']);
        } else if (section.uid === 'SKILLSCHECKER') {
            this.nav.navigate(['/skills-checker']);
        } else if (section.sections.length > 0) {
            this.toggleButtons(section.id);
        } else if (!!section.template) {
            this.goToJourney(section.template.template_id)
        }
    }

    toggleButtons(section_id) {
        this.isOpened = this.toggleSectionId === section_id ? !this.isOpened : true;
        this.toggleSectionId = section_id;
    }

    goToLink(link) {
        this.nav.toLink(link);
    }

    goToJourney(template_id) {
        this.userService.setUserDelegateTemplate(template_id);
        let myTemplate = this.userService.getUserDelegateTemplate();

        if (myTemplate.stages.active.length > 0) {
            this.userService.switchJourney(template_id).then((res) => {
                if (res !== null) {
                    this.router.navigate(['/journey', myTemplate.stages.active[0]]);
                }
            });
        }
    }

    goToReport360() {
        if (this.link360.hasOwnProperty(this.userInfo.id.toString())) {
            this.nav.toLink(this.link360[this.userInfo.id.toString()]);
        }
    }

    runTask(task: TasksModel) {
        this.tasksService.runTask(task);
    }

    goToInsights() {
        this.nav.navigate(['/resources'])
    }

    goToLeaderboard() {
        this.nav.navigate(['/leaderboard'])
    }

    goToSocial() {
        this.nav.navigate(['/social'])
    }

    ngOnDestroy(): void {
        if (!!this.interval) {
            clearInterval(this.interval);
        }
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
